import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

//import * as d3 from 'd3';

const styles = theme => ({
  productionTitle:{
    fontSize:'1.1em',
    fontWeight:700,
    textAlign:'left',
    margin:'0px!important',
    marginBlockStart:'0px!important',
    marginBlockEnd:'0px!important',
    marginLeft:'5px',
  },
});

function ProductionTitle(props) {
  const { classes } = props;
  /*
  let locale = d3.timeFormatDefaultLocale({
    "decimal": ",",
    "thousands": ".",
    "grouping": [3],
    "currency": ["€", ""],
    "dateTime": "%a %b %e %X %Y",
    "date": "%d.%m.%Y",
    "time": "%H:%M:%S",
    "periods": ["AM", "PM"],
    "days": ["zondag", "maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag"],
    "shortDays": ["Zo", "Ma", "Di", "Wo", "Do", "Vr", "Za"],
    "months": ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"],
    "shortMonths": ["Jan", "Feb", "Maa", "Apr", "Mei", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dec"]
  })
  */
  
  let title
  switch (props.lang) {
    case "de":
        title = "Énergie  en Wallonie aujourd'hui"
      break
    case "en":
        title =  "Energy in Wallonie today"
      break
    case "fr":
        title = "Énergie  en Wallonie aujourd'hui"
      break
    case "nl":
    default:
        title = "Groenestroomproductie in Vlaanderen"
  }

  return (
    <p className={classes.productionTitle +' darkbluegreen'}>{title}</p>
  );
}

ProductionTitle.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ProductionTitle);
